import { render, staticRenderFns } from "./RichTextRenderer.vue?vue&type=template&id=e81e8c50"
import script from "./RichTextRenderer.vue?vue&type=script&lang=js"
export * from "./RichTextRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports